class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><g clip-path="url(#a)"><path d="m1.636.929-.707.707 13.435 13.435.707-.707L1.636.929Zm5.311 3.899L9.935 2.3l-.59-.59L10 1l5 4.95-.705.705-.595-.59-2.528 2.988-.707-.707L13 5.355 10.645 3l-2.99 2.535-.708-.707Z"></path><path d="M9.816 9.111 8.13 11.1 4.9 7.87l1.99-1.686-.709-.708-1.99 1.684-.86-.855L2.624 7l2.83 2.84L1 14.29l.705.71 4.455-4.455L9 13.375l.695-.71-.855-.855 1.684-1.99-.708-.709Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs></svg>';
  }
}
const t = "pi-unpin";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
